import { render, staticRenderFns } from "./PackageStatistic.vue?vue&type=template&id=61de5a00&scoped=true"
import script from "./PackageStatistic.vue?vue&type=script&lang=js"
export * from "./PackageStatistic.vue?vue&type=script&lang=js"
import style0 from "./PackageStatistic.vue?vue&type=style&index=0&id=61de5a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de5a00",
  null
  
)

export default component.exports